import React, { useEffect, useState } from "react";
import SearchInput from "../../../../../../../../global components/Forms/SearchInput/SearchInput";
import s from "./Filters.module.scss";
import Paginate from "../../../../../../../../global components/Paginate/Pagination";
import ReusablePopover from "../../../../../../../../global components/Popover/ReuseablePopover";
import { FilterIcon } from "../../../../../../../../global components/Icons/FilterIcon";
import FiltersPopOverContent from "../FiltersPopOverContent";
type PropType = {
  handleTableSearch: (value: string) => void;
  handlePageChange: (page: number, pageSize: number) => void;
  pageSize: number;
  totalDocs: number;
  handleStatus: (status: "" | "approved" | "rejected" | "pending") => void;
};
function Filters({
  handleTableSearch,
  pageSize,
  totalDocs,
  handlePageChange,
  handleStatus,
}: PropType) {
  const handleSearch = (value: string) => {
    handleTableSearch(value);
  };
  const [filter, setFilter] = useState<{
    all: boolean;
    pending: boolean;
    approved: boolean;
    rejected: boolean;
  }>({
    all: true,
    approved: false,
    pending: false,
    rejected: false,
  });
  const handlePage = (page: number, pageSize: number) => {
    handlePageChange(page, pageSize);
  };

  useEffect(() => {
    handleStatus(
      filter.all
        ? ""
        : filter.approved
          ? "approved"
          : filter.pending
            ? "pending"
            : "rejected",
    );
  }, [filter.all, filter.approved, filter.pending, handleStatus]);
  return (
    <div className={s.wrapper}>
      <div className={s.searchInput}>
        <SearchInput
          style={{ width: "100%", height: "100%" }}
          placeholder="search by user name"
          width={332}
          height={45}
          handleSearch={handleSearch}
        />
      </div>
      <div className={s.filters}>
        <ReusablePopover
          trigger={"hover"}
          content={
            <FiltersPopOverContent filter={filter} setFilter={setFilter} />
          }
        >
          <button className={s.filter}>
            <FilterIcon className={s.filterIcon} />
            <p>Filter</p>
          </button>
        </ReusablePopover>
        <Paginate onChange={handlePage} pageSize={pageSize} total={totalDocs} />
      </div>
    </div>
  );
}

export default Filters;
